<template>
  <div>
    <el-form ref="operaForm" :model="operaForm" :rules="rules" label-width="120px">
      <!-- 服务开单，预约服务单 -->
      <template v-if="dialogType === 1 || dialogType === 2">
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="会员手机号" prop="phone">
              <el-input
                v-model="operaForm.phone"
                autocomplete="off"
                placeholder="请输入会员手机号"
                style="width:220px"
                id="telphoneInput"
                @blur="checkTel(operaForm.phone)"
                @keyup.enter.native="checkBlur"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="姓名">{{operaForm.name}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="项目" prop="servicePro" class="serviceProListError">
                <template v-if="!serviceProListnoLock">
                    <span>--</span>
                </template>
                <template v-else-if="serviceProListnoLock.length > 0">
                    <el-checkbox-group v-model="operaForm.servicePro" class="checkBoxcom">
                        <div v-for="(i,index) in serviceProListnoLock" :key="index">
                            <el-checkbox :label="i">{{i.serviceName}}</el-checkbox>
                            <el-tag class="redLine" v-if="i.courseStyle">{{i.courseStyle == 1 ? ('剩余'+i.serviceLeftCount+'次'):i.courseStyle == 2?('截止'+i.serviceEndDate):''}}</el-tag>
                        </div>
                    </el-checkbox-group>
                </template>
                <template v-else>
                    <span class="red">抱歉！暂无剩余项目</span>
                </template>
            </el-form-item>
            <el-form-item v-if="dialogType === 1"><span class="red">注：请仔细核对会员信息！</span></el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!serviceProListnoLock || serviceProListnoLock.length > 0">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="员工" prop="nthmen" v-if="dialogType === 1">
              <el-select
                v-model="operaForm.nthmen"
                placeholder="请选择员工"
                style="width:180px;margin:0 0 10px"
              >
                <el-option v-for='(i,index) in curNthmenList' :key="index" :label="i.name" :value="i.authCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="员工" prop="nthmen" v-else>
              <el-select
                v-model="operaForm.nthmen"
                placeholder="请选择员工"
                style="width:180px;margin:0 0 10px"
              >
                <el-option v-for='(i,index) in nthmenList' :key="index" :label="i.name" :value="i.authCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="(!serviceProListnoLock || serviceProListnoLock.length > 0) && dialogType === 2">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <!-- <el-form-item label="服务时间" prop="servicetime">
              <el-date-picker
                v-model="operaForm.servicetime"
                type="datetime"
                placeholder="选择服务时间"
                style="width:180px"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions1"
                :default-time="defaultTime"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="服务时间" prop="servicetime" class="serviceProListError">
              <el-date-picker
                v-model="operaForm.servicetime"
                type="date"
                placeholder="选择服务日期"
                style="width:150px"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions1"
                :default-time="defaultTime"
              ></el-date-picker>
              <el-time-select placeholder="起始" v-model="operaForm.startTime" style="width:100px" :picker-options="{start: conputedNow,end: computedEnd}"></el-time-select>
              <el-time-select placeholder="结束" v-model="operaForm.endTime" style="width:100px" :picker-options="{start: computedStart ,end: shopHours.split('-')[1] ,minTime: operaForm.startTime}"></el-time-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row v-if="dialogType === 1 && (!serviceProListnoLock || serviceProListnoLock.length > 0)">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="消费密码" prop="payPwd" :class="{'paypass':!setpayPwd}">
              <el-input type="password" v-model="operaForm.payPwd" autocomplete="off" placeholder="请输入消费密码" style="width:180px" :disabled="setpayPwd == 1 || setpayPwd == 2"></el-input>&nbsp;&nbsp;<span class="forget red" @click="forgetPwd" v-if="!setpayPwd">忘记密码？</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="dialogType === 1 && (!serviceProListnoLock || serviceProListnoLock.length > 0)">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <span class="grey" v-if="!setpayPwd">请顾客输入6位数消费密码</span>
              <div class="red" v-else>会员未设消费密码&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="primary" plain size="mini" round @click="toSetPwd">去设置</el-button></div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="erCode">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <img src="../../assets/images/androidimg.png" alt="">
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="erCode">
          <el-col :span="6">
            <div class="seize"></div>
          </el-col>
          <el-col :span="18" class="scanFont">
              <p><b class="red">需顾客</b>打开憨妈妈小程序/APP的扫一扫，</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;扫描下方二维码，点击确认即可。</p>
          </el-col>
        </el-row> -->
        <el-row v-if="dialogType === 2 && (!serviceProListnoLock || serviceProListnoLock.length > 0)">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="服务方式" prop="serviceType">
              <el-radio-group v-model="operaForm.serviceType">
                <el-radio :label="0">到店</el-radio>
                <el-radio :label="1">上门</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="dialogType === 2 && operaForm.serviceType === 1 && (!serviceProListnoLock || serviceProListnoLock.length > 0)">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="联系地址" required>
              <el-form-item prop="serviceProvince">
                <el-select v-model="operaForm.serviceProvince" @change="choseProvince" placeholder="省级地区">
                  <el-option
                    v-for="item in province"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="serviceCity">
                <el-select v-model="operaForm.serviceCity" @change="choseCity" placeholder="市级地区">
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="serviceBlock">
                <el-select v-model="operaForm.serviceBlock" @change="choseBlock" placeholder="区/县级地区">
                  <el-option
                    v-for="item in blockList"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="serviceAddress">
                <el-input v-model="operaForm.serviceAddress" placeholder="详细地址" style="width:220px"></el-input>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="dialogType === 2 && (!serviceProListnoLock || serviceProListnoLock.length > 0)">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item prop="leaveMsg">
              <el-input type="textarea" v-model="operaForm.leaveMsg" autocomplete="off" placeholder="留言，200字以内" style="width:220px;height:90px;" resize="none"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialogbtnOptions" v-if="!serviceProListnoLock || serviceProListnoLock.length > 0">
          <el-button class="darkBtn" @click="cancel">取消</el-button>
          <el-button class="redBtn" v-if="dialogType === 2" @click="appointOrder" :disabled="openFlag">提交预约单</el-button>
          <el-button class="redBtn" v-else @click="openOrder" :disabled="openFlag">开单</el-button>
        </el-row>
        <el-row class="dialogbtnOptions" v-else style="margin-top:60px">
          <el-button class="redBtn" @click="goBuy">去购服务项目</el-button>
        </el-row>
        <el-row class="dialogbtnOptions" v-if="serviceProListnoLock && serviceProListnoLock.length == 0" style="margin-top:130px">
          <el-button class="darkBtn" @click="closeOpen">关闭</el-button>
        </el-row>
      </template>
      <!-- 创建会员 -->
      <template v-else-if="dialogType == 3">
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item :label="$store.state.userInfo.brandId == 1 ?'会员姓名':'家长姓名'" prop="memname">
              <el-input
                v-model="operaForm.memname"
                autocomplete="off"
                :placeholder="$store.state.userInfo.brandId == 1 ?'请输入会员姓名':'请输入家长姓名'"
                style="width:220px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin:10px 0">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="联系方式" prop="phone">
              <el-input
                v-model="operaForm.phone"
                autocomplete="off"
                placeholder="请输入联系方式"
                style="width:220px"
                @blur="checkTel(operaForm.phone)"
                @keyup.enter.native="checkTel(operaForm.phone)"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="$store.state.userInfo.brandId == 1">
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="20">
              <el-form-item label="年龄" prop="age">
                <el-input type="age" v-model="operaForm.age" placeholder="请输入年龄" style="width:195px"></el-input>&nbsp;&nbsp;岁
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin:10px 0">
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="20">
              <el-form-item label="生日" prop="memberBirth">
                <el-date-picker type="date" placeholder="月/日" format="MM 月 dd 日" v-model="operaForm.memberBirth" style="width: 220px;" value-format="MM-dd" ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="20">
              <el-form-item label="所处阶段" prop="procreate">
                <el-select v-model="operaForm.procreate" placeholder="请选择所处阶段" style="width:220px;">
                  <el-option label="孕前" value="3"></el-option>
                  <el-option label="妊娠" value="1"></el-option>
                  <el-option label="产后" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="$store.state.userInfo.brandId != 1">
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="20">
              <el-form-item label="孩子姓名" prop="childName">
                <el-input
                  v-model="operaForm.childName"
                  autocomplete="off"
                  placeholder="请输入孩子姓名"
                  style="width:220px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin:10px 0">
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="20">
              <el-form-item label="孩子性别" prop="childSex">
                <el-radio-group v-model="operaForm.childSex">
                  <el-radio label="1">男孩</el-radio>
                  <el-radio label="2">女孩</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin:0 0 10px">
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="20">
              <el-form-item label="孩子出生日期" prop="childBirth">
                <el-date-picker type="date" placeholder="年/月/日" format="yyyy 年 MM 月 dd 日" v-model="operaForm.childBirth" style="width: 220px;" value-format="timestamp" ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="20">
              <el-form-item>
                <span class="red">*&nbsp;更多资料请去会员信息中填写</span>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <el-row class="dialogbtnOptions">
          <el-button class="darkBtn" @click="cancel">取消</el-button>
          <el-button class="redBtn" @click="addmem" :disabled="openFlag">提交</el-button>
        </el-row>
      </template>
      <!-- 充值 -->
      <template v-else-if="dialogType === 4">
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="会员手机号" prop="phone">
              <el-input
                v-model="operaForm.phone"
                autocomplete="off"
                placeholder="请输入会员手机号"
                style="width:220px"
                id="telphoneInput"
                @blur="checkTel(operaForm.phone)"
                @keyup.enter.native="checkBlur"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="姓名">{{operaForm.name}}</el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:10px" v-if="$store.state.userInfo.brandId != 1">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="销售员" prop="saleMen">
              <el-select v-model="operaForm.saleMen" value-key="staffId" placeholder="请选择销售员" style="width:200px;">
                <el-option
                  v-for="i in staffList"
                  :label="i.staffName"
                  :value="i"
                  :key="i.staffId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="充值金额" prop="rechargeAmount">
              <el-input
                v-model="operaForm.rechargeAmount"
                autocomplete="off"
                placeholder="¥ 0.00"
                style="width:200px"
                class="memMoney redFont"
              ></el-input>&nbsp;&nbsp;元
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin:10px 0">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="赠送金额" prop="giftAmount">
              <el-input
                v-model="operaForm.giftAmount"
                autocomplete="off"
                placeholder="¥ 0.00"
                style="width:200px"
                class="memMoney"
              ></el-input>&nbsp;&nbsp;元
            </el-form-item>
            <div style="padding-left:120px"><span class="red">立即到账</span></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="返现金额" prop="needReturnAmount">
              <el-input
                v-model="operaForm.needReturnAmount"
                autocomplete="off"
                placeholder="¥ 0.00"
                style="width:200px"
                class="memMoney"
              ></el-input>&nbsp;&nbsp;元
            </el-form-item>
            <div style="padding-left:120px"><span class="red">按周期返现，过有效期自动清零</span></div>
          </el-col>
        </el-row>
        <el-row style="margin:10px 0 0">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-form-item label="返现周期" prop="returnCycle">
              <el-input
                v-model="operaForm.returnCycle"
                autocomplete="off"
                placeholder="请输入返现周期"
                style="width:130px"
              ></el-input>&nbsp;&nbsp;个月
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialogbtnOptions">
          <el-button class="darkBtn" @click="cancel">取消</el-button>
          <el-button class="redBtn" @click="submit">支付</el-button>
        </el-row>
      </template>
      <!-- 支付方式 -->
      <template v-else-if="dialogType === 5">
        <div class="payChoose">
          <el-row>
            <el-col>
              <el-form-item label="支付选择" class="fontWeight">
                <el-col :span='6' v-for="(i,index) in 4" :key="'pay-'+index">
                  <div :class="['paystyle','paystyle'+index,{'active':index == activeName}]" @click="choosePayamount(index)">
                    <span>{{index == 0 ? '现金':(index == 1 ? '支付宝':(index == 2?'微信':'银行卡'))}}</span>
                  </div>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="seize"></div>
            </el-col>
            <el-col :span="17">
              <el-form-item label="支付金额" :prop="activeName == 0? 'cash':(activeName == 1?'aliPay':(activeName == 2?'wechatPay':'bankCard'))" class='serviceProListError'>
                  <el-input v-model="payAmount" placeholder="¥ 0.00" autocomplete="off" style="width:260px" class="memMoney chooseMoney redFont"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row class="totalpayAmount">
            <el-col :span="12">
                <p>应收<span>¥ {{totalAmout}}</span></p>
            </el-col>
            <el-col :span="12">
                <p class="netreceipts">实收<span>¥ {{payAmount?payAmount:0.0}}</span></p>
            </el-col>
            <el-col :span="12">
                <p>找零<span>¥ {{giveChange}}</span></p>
            </el-col>
        </el-row>
        <el-row class="dialogbtnOptions">
          <el-button class="darkBtn" @click="cancel">取消</el-button>
          <el-button class="redBtn" @click="submitPay" :disabled="openFlag">确定</el-button>
        </el-row>
      </template>
    </el-form>
    <!-- 开单发票 -->
    <div id="printContOpen" style="display:none">
      <div class="contBox">
        <div class="cont">
          <div>单号：{{printDataPost.id}}</div>
          <div>序号：{{printDataPost.sequence}}</div>
          <div>营业员：{{printDataPost.technicianNameStore}}</div>
          <div>开单时间：{{printDataPost.createTime}}</div>
        </div>
        <div class="table">
          <div>
            <div class='span12'>服务名称</div>
            <div class='span6'>数量</div>
            <div class='span6'>剩余</div>
          </div>
          <div v-for="(i,index) in printDataPost.serviceInfoList" :key="index">
            <div class='span12'>{{i.serviceName}}</div>
            <div class='span6' style="vertical-align:top">1次</div>
            <div class='span6' style="vertical-align:top">{{i.courseStyle == 1 ? ((i.serviceLeftCount - 1 - i.serviceLockCount)+'次'):i.courseStyle == 2?(i.serviceEndDate):''}}</div>
          </div>
        </div>
        <div class="cont">
          <div>技师：{{printDataPost.technicianStoreName}}</div>
          <div>会员：{{printDataPost.memberName}}</div>
          <div>手机号：{{printDataPost.memberTelephone?(printDataPost.memberTelephone.substr(0,3)+'****'+printDataPost.memberTelephone.substr(7)):''}}</div>
        </div>
        <div class="printbottomset">
          <div>{{printBottomContent}}</div>
          <div>{{$store.state.userInfo.brandId == 1?"产后恢复，当然婷美！":'孩子少生病，全家都省心！'}}</div>
          <div>凭电话号码和姓名消费，注意保密！</div>
        </div>
      </div>
    </div>
    <!-- 充值小票 -->
    <div id="printRechargeCont" style="display:none">
      <div class="contBox">
        <div class="cont">
          <div>充值单号：{{printRechargePost.rechargeId}}</div>
          <div>充值员：{{printRechargePost.cashierName}}</div>
          <div style="width: 100%; overflow: hidden;">充值时间：{{printRechargePost.createTime}}</div>
        </div>
        <div class="cont">
          <div>充值金额：{{Number(printRechargePost.rechargeAmount).toFixed(2)}}</div>
          <div>赠送金额：{{Number(printRechargePost.giftAmount).toFixed(2)}}</div>
          <div>返现金额：{{Number(printRechargePost.needReturnAmount).toFixed(2)}}</div>
          <div>返现周期：{{printRechargePost.returnCycle}}个月</div>
        </div>
        <div class="cont">
          <div>会员名称：{{payDatadetail.name}}</div>
          <div>会员联系方式：{{payDatadetail.phone ? (payDatadetail.phone.substr(0,3)+'****'+payDatadetail.phone.substr(7)):''}}</div>
        </div>
        <div class="printbottomset">
          <div>{{printBottomContent}}</div>
          <div>{{$store.state.userInfo.brandId == 1?"产后恢复，当然婷美！":'孩子少生病，全家都省心！'}}</div>
          <div>凭电话号码和姓名消费，注意保密！</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {memDetail, allStaff, storeInfo, memberServiceList, technicianList, insertMemRecharge, insertMem, addServiceOrder, checkMemAccountPwd} from '@/api';
import CryptoJS from 'crypto-js'
import {
  formatDate
} from '@/components/common/js/date.js';
let LODOP//声明为全局变量

export default {
  props: ["dialogType","dialogTableVisible"],
  data() {
      /*验证手机号*/
    const isvalidateMobile = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^1[3456789]\d{9}$/.test(value) == false) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 数字,最大100
    const isvalidateNumber = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^[1-9]\d*$/.test(value) == false) {
          callback(new Error("请输入正整数"));
        } else if (Number(value) > 100) {
          callback(new Error("最大为100"));
        } else {
          callback();
        }
      } else if(this.operaForm.needReturnAmount){
        callback(new Error("请输入1~100的正整数"));
      } else {
        callback();
      }
    };
    const isvalidaReturnMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("只能为正数或两位小数"));
        } else if (value > (this.$store.state.userInfo.brandId == 1 ? 99999.99:9999.99)) {
          callback(new Error("金额最大"+(this.$store.state.userInfo.brandId == 1 ? 99999.99:9999.99)));
        } else {
          callback();
        }
      } else if(this.operaForm.returnCycle){
        callback(new Error("请填写返现金额"));
      } else {
        callback();
      }
    };
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("只能为正数或两位小数"));
        } else if (value > (this.$store.state.userInfo.brandId == 1 ? 99999.99:9999.99)) {
          callback(new Error("金额最大"+(this.$store.state.userInfo.brandId == 1 ? 99999.99:9999.99)));
        } else {
          callback();
        }
      } else if(!this.operaForm.rechargeAmount && !this.operaForm.giftAmount && !this.operaForm.needReturnAmount && !this.operaForm.returnCycle){
        callback(new Error("请填写至少一项金额"));
      } else {
        callback();
      }
    };
    const isvalidateSMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
          callback(new Error("只能为正数或两位小数"));
        } else if (value > (this.$store.state.userInfo.brandId == 1 ? 99999.99:9999.99)) {
          callback(new Error("金额最大"+(this.$store.state.userInfo.brandId == 1 ? 99999.99:9999.99)));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 密码
    var validatePass = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为数字，请设置正确格式的密码"));
      // } else if (value.length < 6) {
      //   callback(new Error("密码太短"));
      } else if (value.length > 6) {
        callback(new Error("密码长度只可以是6位"));
      } else {
        callback();
      }
    };
    // 数字(正整数)
    const isvalidateNumberage = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^[1-9]\d*$/.test(value) == false) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 数字(一位小数，身高/体重/母乳时长)
    const isvalidateNumberPoint = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^\d*\.{0,1}\d{0,1}$/.test(value) == false) {
          callback(new Error("请输入数字，最多一位小数"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isvalidaDate = (rule, value, callback) => {
      if (!value || value == "") {
        callback(new Error("请选择服务时间"));
      }else if(!this.operaForm.startTime || this.operaForm.startTime == ''){
        callback(new Error("请选择服务开始时间"));
      }else if(!this.operaForm.endTime || this.operaForm.endTime == ''){
        callback(new Error("请选择服务结束时间"));
      }else{
        callback()
      }
    };
    return {
      pickerOptions1:{
        disabledDate(time) {
          return time.getTime() < (Date.now() - 3600 * 1000 * 24);
        },
      },
      operaForm: {
        memname:'',
        childName:'',
        childSex:'1',
        age:'',
        memberBirth:'',
        childBirth:'',
        procreate:'',
        phone: "",
        name: "--",
        saleMen:'',
        nthmen: "",
        servicetime: "",
        startTime:'',
        endTime:'',
        serviceType:0,
        rechargeAmount:'',
        cash:'',
        wechatPay:'',
        aliPay:'',
        bankCard:'',
        giftAmount:'',
        needReturnAmount:'',
        returnCycle:'',
        servicePro:[],
        payPwd:'',
        serviceProvince: '',
        serviceCity: '',
        serviceBlock: '',
        serviceAddress:'',
        leaveMsg:''
      },
      province:'',
      cityList: [],
      blockList: [],
      city:'',
      block:'',
      serviceProList:'',
      nthmenList:'',
      staffList:'',
      rules: {
          phone:[
              {
                required: true,
                message: "请输入会员手机号",
                trigger: "blur"
            },
            { validator: isvalidateMobile, trigger: "blur" }
          ],
          memname:[
            { required: true, message: "请输入会员姓名", trigger: "blur" },
            { min: 0, max: 15, message: "最多 15 个字符", trigger: "blur"}
          ],
          childName:[
            { required: true, message: "请输入孩子姓名", trigger: "blur" },
            { min: 0, max: 15, message: "最多 15 个字符", trigger: "blur"}
          ],
          age:[
            { required: true, message: "请输入年龄", trigger: "blur" },
            { type: "number", validator: isvalidateNumberage, trigger: "blur" }
          ],
          memberBirth:[
            { required: true, message: '请选择生日', trigger: 'change' }
          ],
          childSex:[
            { required: true, message: '请选择孩子性别', trigger: 'change' }
          ],
          childBirth:[
            { required: true, message: '请选择孩子出生日期', trigger: 'change' }
          ],
          procreate:[
            { required: true, message: "请选择所处阶段", trigger: "change" },
          ],
          saleMen:[
            { required: true, message: '请选择销售员', trigger: 'change' }
          ],
          rechargeAmount:[
            { type: "number", validator: isvalidateMoney }
          ],
          cash:[
            { type: "number", validator: isvalidateMoney }
          ],
          wechatPay:[
            { type: "number", validator: isvalidateMoney }
          ],
          aliPay:[
            { type: "number", validator: isvalidateMoney }
          ],
          bankCard:[
            { type: "number", validator: isvalidateMoney }
          ],
          giftAmount:[
            { type: "number", validator: isvalidateSMoney }
          ],
          needReturnAmount:[
            { type: "number", validator: isvalidaReturnMoney }
          ],
          returnCycle:[
            {
                validator: isvalidateNumber,
                trigger: "blur"
            }
          ],
          servicePro:[
            { required: true, message: '请至少选择一个项目', trigger: 'change' }
          ],
          nthmen:[
            { required: true, message: '请选择员工', trigger: 'change' }
          ],
          servicetime:[
            // { required: true, message: '请选择服务时间', trigger: 'change' }
            {validator: isvalidaDate, trigger:'change'}
          ],
          payPwd:[
            { required: true, message: "请输入消费密码", trigger: "blur" },
            { validator: validatePass, trigger: "blur"}
          ],
          serviceType:[
            { required: true, message: "请选择服务方式", trigger: "change" },
          ],
          serviceProvince:[
            { required: true, message: "请选择联系地址所在省", trigger: "change" },
          ],
          serviceAddress:[
            { required: true, message: "请输入详细地址", trigger: "blur" },
            { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur"}
          ],
          leaveMsg:[
            { min: 1, max: 200, message: "长度在 1 到 200 个字符", trigger: "blur"}
          ]
      },
      openFlag:false,//点击按钮保持唯一性
      printTopContent:'',
      printBottomContent:'',
      brandName:'',
      printDataPost:'',
      printRechargePost:'',
      erCode:false,
      setpayPwd:0, //未设置消费密码
      shopHours:'',
      activeName:0,
      payAmount:'',
      totalAmout:0.0,
      payDatadetail:'',
	    pagerNumber:2
    };
  },
  watch: {
    'dialogType'(val){
      this.$refs.operaForm.clearValidate();
      this.operaForm = this.$options.data().operaForm;
      this.printDataPost = '';
      this.printRechargePost = '';
      this.serviceProList = '';
      this.erCode = false;
      if(val == 1 || val == 2 || val == 4){
        this.techList();
        if(val == 4 && this.$store.state.userInfo.brandId != 1){
          this.searchStaff();
        }
        if(val == 2){
          this.setDefaultVal();
        }
      }
      this.openFlag = false
    },
    'dialogTableVisible'(val){
      this.operaForm = this.$options.data().operaForm;
      if(val == 1){
        this.techList();
        this.setDefaultVal();
      }
      if(this.dialogType == 4 && this.$store.state.userInfo.brandId != 1){
        this.searchStaff();
      }
      this.erCode = false;
      this.printDataPost = '';
      this.printRechargePost = '';
      this.serviceProList = '';
      this.openFlag = false;
      this.setpayPwd = 0;
      this.payAmount = '';
      this.payDatadetail = '';
      this.activeName = 0;
      setTimeout(()=>{
        this.$refs.operaForm.clearValidate();
      })
    },
    'operaForm.servicetime'(val){
      // if(new Date(val).getTime() < (new Date().getTime() + 2 * 3600 * 1000)){
      //   this.operaForm.servicetime = new Date(new Date().getTime() + 2 * 3600 * 1000);
      // }
    },
    payAmount(){
      this.changepayAmount()
    },
    activeName(){
      this.changepayAmount()
    },
  },
  created() {
    if(this.dialogType == 1 || this.dialogType == 2 || this.dialogType == 4){
      this.techList();
      if(this.dialogType == 4 && this.$store.state.userInfo.brandId != 1){
        this.searchStaff();
      }
      this.openFlag = false
    }
    this.getCityData()
  },
  computed: {
    conputedNow(){
      // 和本地时间做对比
      let time = '09:00'
      if(this.shopHours){
        time = this.shopHours.split('-')[0].split(':')[0] > 9 ? this.shopHours.split('-')[0] : '0'+this.shopHours.split('-')[0];
        let hours = new Date().getMinutes() > 30 ? new Date().getHours()+1+':00' : new Date().getHours()+':30';
        let nowDate = formatDate(this.operaForm.servicetime,'yyyy-MM-dd'),location=formatDate(new Date(),'yyyy-MM-dd');
        time = nowDate == location ? (Number(time.split(':')[0]) > Number(hours.split(':')[0]) ? time : hours) : time
        if(Number(time.split(':')[0]) >= Number(this.shopHours.split('-')[1].split(':')[0]) && Number(time.split(':')[1]) >= Number(this.shopHours.split('-')[1].split(':')[1])){
          this.$message({
            type: "warning",
            message: '今日已无预约时间，请选择明天'
          });
        }
      }
      return time;
    },
    computedEnd(){
      let time = '17:00'
      if(this.shopHours){
        time = this.shopHours.split('-')[1];
        let hours = Number(time.split(':')[0])-1;
        time = (hours<10?'0'+hours:hours) +':'+  time.split(':')[1]
      }
      return time;
    },
    computedStart(){
      let time = '10:00'
      if(this.shopHours){
        time = this.shopHours.split('-')[0];
        let hours = Number(time.split(':')[0])+1;
        time = (hours<10?'0'+hours:hours) +':'+  time.split(':')[1]
      }
      return time;
    },
    curNthmenList(){
      if(this.nthmenList){
        return this.nthmenList.filter(function (staff) {
          return staff.status == 0
        })
      }
    },
    defaultTime(){
      // return (new Date().getHours() + 2)+':'+(new Date().getMinutes())+':'+(new Date().getSeconds())
    },
    serviceProListnoLock(){
      // 不包括锁定的服务
      let data = this.serviceProList?[]:'';
      for(let i of this.serviceProList){
        if(i.courseStyle == 1 ){
          if((i.serviceLeftCount - i.serviceLockCount) > 0){
            i.serviceLeftCount = i.serviceLeftCount - i.serviceLockCount
            data.push(i)
          }
        }else{
          data.push(i)
        }
      }
      return data;
    },
    servicePost(){
      let serviceInfoList=[];
      for(let i of this.operaForm.servicePro){
        serviceInfoList.push({
          serviceId:i.serviceId,
          serviceName:i.serviceName,
          courseStyle:i.courseStyle,
          changeFrequency:1
        })
      }
      this.operaForm.servicetime = formatDate(this.operaForm.servicetime,'yyyy-MM-dd ')
      let post = {
        isAppoint:this.dialogType == 2 ? 1:0,
        memberId:this.operaForm.memberId,
        memberName:this.operaForm.name,
        memberTelephone:this.operaForm.phone,
        memberFaceUrl:this.operaForm.faceUrl,
        technicianAuthCode:this.operaForm.nthmen,
        scheduleStartTime:this.dialogType === 1 ? null : this.operaForm.servicetime+this.operaForm.startTime+':00',
        scheduleEndTime:this.dialogType === 1 ? null : this.operaForm.servicetime+this.operaForm.endTime+':00',
        isHome:this.operaForm.serviceType?this.operaForm.serviceType:0,
        serviceAddr:this.operaForm.serviceAddress?this.operaForm.serviceAddress:this.$store.state.userInfo.storeAddress,
        serviceInfoList:serviceInfoList
      }
      return post;
    },
    printPost(){
      // 打印数据
      return function(data){
        let serviceInfoList=[];
        for(let i of this.operaForm.servicePro){
          serviceInfoList.push({
            serviceName:i.serviceName,
            courseStyle:i.courseStyle,
            serviceLeftCount:i.serviceLeftCount,
            serviceEndDate:formatDate(i.serviceEndDate,'yyMMdd'),
          serviceLockCount:i.serviceLockCount,
          })
        }
        let post = {
          id:data.id,
          sequence:data.sequence,
          technicianNameStore:data.technicianNameStore,
          createTime:formatDate(data.createTime,'yyyy-MM-dd HH:mm'),
          serviceInfoList:serviceInfoList,
          technicianStoreName:data.technicianName,
          memberName:data.memberName,
          memberTelephone:data.memberPhone
        };
        return post;
      }
    },
    giveChange(){
        return (this.payAmount - this.totalAmout).toFixed(2)
    },
  },
  methods: {
    searchStaff(){
      allStaff({
        status:'1',
        staffType:'1',
        deleteFlag:'0'
      }).then(res=>{
        this.staffList = res.data;
      })
    },
    techList(){
      technicianList({
        // status:'1',
        // deleteFlag:'0',
        // postId:'0'
      }).then(res=>{
        this.nthmenList = res.data;
      })
      storeInfo().then(res => {
        if (res.code == 1) {
          this.brandName = res.data.brandId == 1 ? '婷美摩力21产后恢复' : (res.data.brandId == 2 ? '臻幼堂小儿推拿' : '槑博士婴幼儿草本浴');
          this.printTopContent = res.data.brandId == 1 ? res.data.printTopContent.split('婷美')[0]:(res.data.brandId == 2?res.data.printTopContent.split('臻幼堂')[0]:(res.data.brandId == 3?res.data.printTopContent.split('槑博士')[0]:''));
          this.pagerNumber = res.data.pagerNumber;
          if(!res.data.printBottomContent || res.data.printBottomContent == ''){
            this.printBottomContent = '温馨提示：请核对小票信息是否准确，若有疑问请与前台联系';//默认内容
          }else{
            this.printBottomContent = res.data.printBottomContent;
          }
          this.shopHours = res.data.shopHours;
        }
      });
    },
    choosePayamount(index){
      this.activeName = index;
    },
    changepayAmount(){
      this.operaForm.cash = 0;
      this.operaForm.aliPay = 0;
      this.operaForm.wechatPay = 0;
      this.operaForm.bankCard = 0;
      if(this.activeName == 0){
        this.operaForm.cash = this.payAmount;
      }
      if(this.activeName == 1){
        this.operaForm.aliPay = this.payAmount;
      }
      if(this.activeName == 2){
        this.operaForm.wechatPay = this.payAmount;
      }
      if(this.activeName == 3){
        this.operaForm.bankCard = this.payAmount;
      }
    },
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    forgetPwd(){
      // 展开下面二维码
      this.erCode = true;
    },
    checkBlur(){
      $('#telphoneInput').blur();
    },
    getCityData(){
      let that = this
      let data = this.$store.state.provincialCity
      that.province = []
      that.city = []
      that.block = []
      // 省市区数据分类
      for (let item in data) {
        if (item.match(/0000$/)) {//省
          that.province.push({id: item, value: data[item], children: []})
        } else if (item.match(/00$/)) {//市
          that.city.push({id: item, value: data[item], children: []})
        } else {//区
          that.block.push({id: item, value: data[item]})
        }
      }
      // 分类市级
      for (let index in that.province) {
        for (let index1 in that.city) {
          if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
            that.province[index].children.push(that.city[index1])
          }
        }
      }
      // 分类区级
      for(let item1 in that.city) {
        for(let item2 in that.block) {
          if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
            that.city[item1].children.push(that.block[item2])
          }
        }
      }
      this.$nextTick(()=>{
        this.setDefaultVal()
      })
    },
    setDefaultVal(){
      this.$set(this.operaForm,'serviceProvince',this.$store.state.userInfo.addressProvince)
      this.choseProvince(this.$store.state.userInfo.addressProvince);
      this.$set(this.operaForm,'serviceCity',this.$store.state.userInfo.addressCity)
      this.choseCity(this.$store.state.userInfo.addressCity);
      this.$set(this.operaForm,'serviceBlock',this.$store.state.userInfo.addressArea)
      // this.operaForm.serviceAddress = this.$store.state.userInfo.storeAddress; //详细地址不需要
    },
    // 选省
    choseProvince:function(e) {
      for (let index2 in this.province) {
        if (e === this.province[index2].id) {
          // console.log(this.province[index2].id)//你选择的省级编码
          // console.log(this.province[index2].value)//省级编码 对应的汉字
          this.cityList = this.province[index2].children
          this.operaForm.serviceCity = this.province[index2].children[0].id
          this.blockList =this.province[index2].children[0].children
          this.$set(this.operaForm,'serviceBlock',this.province[index2].children[0].children[0].id)
          this.E = this.blockList[0].id
        }
      }
    },
    // 选市
    choseCity:function(e) {
      for (let index3 in this.city) {
        if (e === this.city[index3].id) {
          this.blockList = this.city[index3].children
          this.$set(this.operaForm,'serviceBlock',this.city[index3].children[0].id)
          this.E = this.blockList[0].id
        }
      }
    },
    // 选区
    choseBlock:function(e) {
      this.E=e;
    },
    checkTel(tel) {
      //   自动检索该会员信息，查不到会员时，toast提示“查不到会员”
      if(/^1[3456789]\d{9}$/.test(tel)){
        memDetail({
          phone:tel
        }).then(res=>{
          // let curServiceType = this.operaForm.serviceType;
          if(this.dialogType == 3){
            if (!res.data.accountOffList || res.data.accountOffList.length == 0) {
              this.$confirm("您已是本系统会员", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "info"
              }).then(() => {
                this.$router.push("/basicDataCenter/phone" + tel);
                this.$emit('closeDialog', false);
              });
            } else {
              this.$confirm("您已是本系统本店会员，可直接列表查看", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "info"
              }).then(() => {
                this.$router.push("/basicDataCenter/baseInfo");
                this.$store.commit("setAliveStatus", true); //保留列表页状态
                sessionStorage.setItem('keyTel',tel);
                this.$emit('closeDialog', false);
              });
            }
          }else{
            if(res.code != 1){
              this.$message({
                type: "warning",
                message: '查不到会员'
              });
            }else{
              this.operaForm = res.data;
              this.$set(this.operaForm,'serviceType',0);
              this.$set(this.operaForm,'servicePro',[]);
              this.erCode = false;
              if(this.dialogType != 4){
                memberServiceList({
                  memberId:res.data.memberId
                }).then(lastRes => {
                  this.serviceProList = lastRes.data;
                  for(let i of this.serviceProList){
                    i.serviceEndDate = formatDate(i.serviceEndDate, 'yyyy-MM-dd');
                  }
                })
                if (!res.data.accountOffList || res.data.accountOffList.length == 0) {
                  // 提交后先走接口1（加入本店会员） 再走接口2（更新会员消费密码）
                  this.setpayPwd = 2;
                } else if(res.data.accountOffList[0].passwordOff == 0){
                  // 提示去设置密码，提交后走更新会员消费密码接口（updateMemberOffPassword）
                  this.setpayPwd = 1;
                }else{
                  this.setpayPwd = 0;
                }
              }
            }
          }
          this.$nextTick(()=>{
            this.$refs.operaForm.clearValidate();
          })
        })
      }
    },
    toSetPwd(){
      this.$emit('cancelDialog',{setpayPwd:this.setpayPwd,memberId:this.operaForm.memberId})
    },
    appointOrder(){
      // 预约服务
      this.$refs.operaForm.validate(valid => {
          if (valid) {
            this.openFlag = true;
            this.servicePost.addressProvince = this.operaForm.serviceProvince;
            this.servicePost.addressCity = this.operaForm.serviceCity;
            this.servicePost.addressArea = this.operaForm.serviceBlock;
            this.servicePost.message = this.operaForm.leaveMsg;

            addServiceOrder(this.servicePost).then(res=>{
              this.$message({
                message: res.msg,
                type: res.code == 1 ? "success" : "error"
              });
              if(res.code == 1){
                this.$emit("closeDialog", false)
                this.$emit('refresh');
                setTimeout(()=>{
                  this.operaForm = this.$options.data().operaForm;
                  this.printDataPost = '';
                  this.serviceProList = '';
                  this.openFlag = false
                })
              }else{
                this.openFlag = false
              }
            })
          } else {
              this.openFlag = false;
              console.log("error submit!!");
              return false;
          }
      })
    },
    openOrder(){
      // 服务开单
      this.$refs.operaForm.validate(valid => {
          if (valid) {
            this.openFlag = true;
            // checkMemAccountPwd({
            //   memberId:this.operaForm.memberId,
            //   passwordOff:this.operaEntryDES(this.operaForm.payPwd)
            // }).then(res=>{
              // if(res.code == 1){
                // this.openFlag = true;
                addServiceOrder(this.servicePost).then(res=>{
                  this.$message({
                    message: res.msg,
                    type: res.code == 1 ? "success" : "error"
                  });
                  if(res.code == 1){
                    this.printDataPost = this.printPost(JSON.parse(res.data));
                    this.$emit('refresh');
                    setTimeout(()=>{
                      this.$emit("closeDialog", false)
                      this.operaForm = this.$options.data().operaForm;
                      this.serviceProList = '';
                      this.openFlag = false;
                      if(getLodop()){
                        this.CreatePrintPage(1);
                        LODOP.SET_PRINT_PAGESIZE(3,0,0,"");
                        LODOP.SET_PRINT_COPIES(Number(this.pagerNumber));
                        LODOP.PRINT();
                      }
                    })
                  }else{
                    this.openFlag = false
                  }
                })
              // }else{
              //   this.openFlag = false;
              //   this.$message({
              //     message: res.msg,
              //     type: "error"
              //   });
              // }
            // })
          } else {
              this.openFlag = false;
              console.log("error submit!!");
              return false;
          }
      })

    },
    CreatePrintPage(type) {
      LODOP=getLodop();
      LODOP.PRINT_INITA('');
      LODOP.ADD_PRINT_TEXT(10,0,'100%','100%',this.printTopContent+String.fromCharCode(13)+this.brandName);
      LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
      LODOP.SET_PRINT_STYLEA(0,"ItemType",1);
      // LODOP.SET_PRINT_STYLEA(0,"Horient",2);
      let brandsize = this.printTopContent ? 58:30

      if(type == 1){
        var strBodyStyle="<style>div{font-size:12px;line-height:18px}div.span12{width: 50%;text-align:center;display: inline-block}div.span6{width: 23%;text-align:center;display: inline-block}div.cont{padding:0 10px}div.table{margin:10px 0}div.printbottomset{padding:10px}</style>";
        var strFormHtml=strBodyStyle+"<body>"+document.getElementById("printContOpen").innerHTML+"</body>";
        LODOP.ADD_PRINT_HTM(brandsize,0,"100%",$("#printContOpen").height(),strFormHtml);
      }else if(type == 2){
        var strBodyStyle="<style>div{font-size:12px;line-height:18px}div.cont{padding:0 10px}div.printbottomset{padding:10px}</style>";
        var strFormHtml=strBodyStyle+"<body>"+document.getElementById("printRechargeCont").innerHTML+"</body>";
        LODOP.ADD_PRINT_HTM(brandsize,0,"100%",$("#printRechargeCont").height(),strFormHtml);
      }
    },
    cancel(){
        // 取消
        this.$message({
            type: "info",
            message: "已取消"
        });
        this.$emit('closeDialog', false);
    },
    addmem(){
      this.$refs.operaForm.validate(valid => {
            if (valid) {
              this.openFlag = true;
              let memData = {};
              if (this.$store.state.userInfo.brandId == 1) {
                memData = {
                  name:this.operaForm.memname,
                  phone:this.operaForm.phone,
                  age:this.operaForm.age,
                  memberBirth:this.operaForm.memberBirth,
                  health:{
                    procreate:this.operaForm.procreate
                  }
                }
              }else{
                memData = {
                  name:this.operaForm.memname,
                  phone:this.operaForm.phone,
                  childList:[{
                    childName:this.operaForm.childName,
                    childSex:this.operaForm.childSex,
                    childBirth:this.operaForm.childBirth
                  }]
                }
              }
              insertMem(memData).then(res=>{
                this.$message({
                  type: res.code == 1 ?"success":'error',
                  message: res.msg
                });
                this.$emit("closeDialog", false)
                this.$nextTick(()=>{
                  this.openFlag = false;
                })
              })
            } else {
              this.openFlag = false;
              console.log("error submit!!");
              return false;
          }
      })
    },
    closeOpen(){
      // 关闭
      this.$message({
          type: "info",
          message: "已关闭"
      });
      this.$emit('closeDialog', false);
    },
    submit(){
        // 提交
        this.$refs.operaForm.validate(valid => {
            if (valid) {
              this.payDatadetail = {
                memberId:this.operaForm.memberId,
                rechargeAmount:this.operaForm.rechargeAmount?this.operaForm.rechargeAmount:0,
                giftAmount:this.operaForm.giftAmount?this.operaForm.giftAmount:0,
                needReturnAmount:this.operaForm.needReturnAmount?this.operaForm.needReturnAmount:0,
                returnCycle:this.operaForm.returnCycle?this.operaForm.returnCycle:0,
              }
              if(this.$store.state.userInfo.brandId != 1){
                this.payDatadetail.staffId = this.operaForm.saleMen.staffId;
                this.payDatadetail.staffName = this.operaForm.saleMen.staffName;
              }
              this.payDatadetail.name = this.operaForm.name;
              this.payDatadetail.phone = this.operaForm.phone;
              this.totalAmout = this.operaForm.rechargeAmount
              this.$emit("closeDialog", 'payClick')
            } else {
                console.log("error submit!!");
                return false;
            }
        })
    },
    submitPay(){
      this.$refs.operaForm.validate(valid => {
        if (valid) {
          this.openFlag = true;
          this.payDatadetail.amountReceivable = this.totalAmout;
          this.payDatadetail.paidinAmount=Number(this.payAmount);
          this.payDatadetail.giveChange=this.giveChange;
          this.payDatadetail.cash=this.operaForm.cash;
          this.payDatadetail.bankCard=this.operaForm.bankCard;
          this.payDatadetail.aliPay=this.operaForm.aliPay;
          this.payDatadetail.wechatPay=this.operaForm.wechatPay;
          if(this.giveChange < 0){
            this.openFlag = false;
            this.$confirm( '实收金额不能小于应收金额', "提示", {
                showCancelButton: false,
                type: "warning"
            })
            return;
          }
          insertMemRecharge(this.payDatadetail).then(res=>{
            this.$message({
              message: res.msg,
              type: res.code == 1 ? "success" : "error"
            });
            if(res.code == 1){
              this.printRechargePost = res.data;
              setTimeout(()=>{
                this.$emit("closeDialog", false)
                this.operaForm = this.$options.data().operaForm;
                this.printDataPost = '';
                this.serviceProList = '';
                this.openFlag = false;
                if(getLodop()){
                  this.CreatePrintPage(2);
                  LODOP.SET_PRINT_PAGESIZE(3,0,0,"");
                  LODOP.SET_PRINT_COPIES(Number(this.pagerNumber));
                  LODOP.PRINT();
                }
              })
            }else{
              this.openFlag = false
            }
          })
        }else {
                this.openFlag = false;
                console.log("error submit!!");
                return false;
            }
        })
    },
    goBuy(){
        this.$emit('closeDialog',false);
        this.$emit('memInfo',this.operaForm.phone+'?'+Date.now());
        this.$router.push('/operatingFloor/collection');
    }
  }
};
</script>
<style>
  @import "../../assets/css/left.css";
</style>

<style lang="less">
.dialogVisible {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .seize {
    height: 20px;
  }
  .totalpayAmount{
    border-top: 1px solid #A3A9B6;
    margin: 20px 20px 0;
    padding: 20px 0 0 30px;
    p{
        color: #444;
        font-size: 16px;
        font-weight: bold;
        span{
            color:#F83B56;
            font-size: 19px;
            margin-left: 5px;
        }
        &.netreceipts{
          span{
            color: #222;
          }
        }
    }
  }
  .el-dialog__title {
    font-weight: bold;
  }
  .el-dialog__body {
    padding: 25px 0 30px;
    max-height:610px;
    overflow-y:scroll;
    /* 多选 */
    .checkBoxcom .el-checkbox__input.is-checked .el-checkbox__inner {
      background: #f83b56;
      border-color: #f83b56;
    }
    .checkBoxcom .el-checkbox__inner:hover,
    .checkBoxcom .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #f83b56;
    }
    .checkBoxcom .el-checkbox__input.is-checked + .el-checkbox__label,
    .el-checkbox__label {
      color: #222;
    }
    .redLine{
        padding: 0 6px;
        height: 20px;
        line-height: 18px;
        font-size: 12px;
        color: #F83B56;
        font-weight: normal;
        border-radius: 0px 10px 10px 10px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        white-space: nowrap;
        border: 1px solid #f83b56;
        background: #fff;
        margin-left: 15px;
    }
  }
  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      color: #999;
    }
    &.paypass{
      .el-form-item__error{
        left: 260px;
      }
    }
    &.serviceProListError{
      margin-bottom: 20px;
      .el-form-item__error{
        top: 98%;
        left: 0;
      }
    }
    .el-form-item__error{
        top: 8px;
        left: 230px;
    }
  }
  .el-form-item__content {
    text-align: left;
    .account {
      margin-left: 10px;
    }
  }
  .memMoney{
      &.redFont{
          .el-input__inner{color:#F83B56;}
      }
      .el-input__inner{
        color:#444;
        font-weight:bold;
        font-size:15px;
        text-align: right
      }
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
    border-radius: 18px;
  }
  .el-textarea__inner {
    height: 100%;
    border-radius: 18px;
  }
  .el-button.redBtn {
    background: #f83b56;
    color: #fff;
  }
  .totalCash {
    height: 46px;
    line-height: 46px;
    background: #eff1f5;
    text-align: center;
    p {
      color: #444;
      font-size: 15px;
      font-weight: bold;
      span {
        color: #f83b56;
        font-size: 19px;
        margin-left: 5px;
      }
    }
  }
  .el-button.darkBtn {
    background: #3b404f;
    color: #fff;
  }
  .dialogbtnOptions {
    margin-top: 26px;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border: none;
    }
  }
  #printContOpen div{font-size:12px;line-height:18px;width:100%; overflow: hidden;}div.span12{width: 50%;text-align:center;display: inline-block}div.span6{width: 23%;text-align:center;display: inline-block}div.cont{padding:0 10px}div.table{margin:10px 0}div.printbottomset{padding:10px}
  #printRechargeCont div{font-size:12px;line-height:18px}
}
</style>



// WEBPACK FOOTER //
// src/components/operatingFloor/operating.vue